(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-skio-selling_plan"] && !Shopify.designMode) return;
  try {
    class SkioSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    connectedCallback() {
      console.log('SkioSellingPlan element connected to DOM');
      this.loadProductData();
      this.setupVariantChangeListener();
    }

    disconnectedCallback() {
      console.log('SkioSellingPlan element disconnected from DOM');
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }

    loadProductData() {
      const product = this.getAttribute('product');
      if (product) {
        try {
          this.product = JSON.parse(product);
        //   console.log('Product data loaded:', this.product);
        } catch (error) {
          console.error('Error parsing product JSON:', error);
        }
      }
    }

    getProduct() {
      return this.product;
    }

    getSellingPlanId(variant) {
      if (this.product && variant) {
        const variantData = this.product.variants.find(v => v.id === parseInt(variant));
        if (!variantData) {
          console.warn('Variant data not found for variant:', variant);
          return null;
        }
        const allocations = variantData.selling_plan_allocations;
        if (allocations && allocations.length > 0) {
          return allocations[0].selling_plan_id || null;
        }
      }
      return null;
    }

    setupVariantChangeListener() {
      const form = this.getAttribute('form');
      if (form) {
        const formElement = document.getElementById(form);
        if (formElement) {
          const variantSelector = formElement.querySelector('.product-variant-id');
          if (variantSelector) {
            variantSelector.addEventListener('change', this.handleVariantChange.bind(this));
            console.log('Variant change listener attached added',);
          } else {
            console.warn('Variant selector (.product-variant-id) not found in form:', form);
          }
        } else {
          console.warn('Form not found with ID:', form);
        }
      }
    }

    handleVariantChange(event) {
      console.log('🎯 VARIANT CHANGE EVENT RECEIVED in SkioSellingPlan 🎯');
      const variant = event.target.value;
      this.updateSellingPlan(variant);
    }

    updateSellingPlan(variant) {
      console.log('Updating selling plan for variant:', variant);
      const sellingPlanId = this.getSellingPlanId(variant);
      
      if (sellingPlanId === null) {
        console.warn('No selling plan ID found for variant:', variant);
        return;
      }
      
      const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        console.log('Selling plan ID updated to:', sellingPlanId);
        
        // Trigger change event to notify other components
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        console.error('Selling plan input not found');
      }
    }

    init() {
      console.log('SkioSellingPlan class initialized');
    }
  }
  
  customElements.define('skio-selling-plan', SkioSellingPlan);
  } catch(e) { console.error(e); }
})();

})();
